module.exports = __webpack_public_path__ + "img/94027.a90751c7.svg";